module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bind-box"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.$t('bindEmail')))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bind-components"
    }
  }, [_c('bind-email', {
    staticClass: "position-center"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60ba2736!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/bind/Index.vue
// module id = 1333
// module chunks = 1